export default {
  data: [
    {
      old_url: '/sg',
      new_url: '/'
    },
    {
      old_url: '/services',
      new_url: '/expertises'
    },
    {
      old_url: '/services/digital-it-advisory',
      new_url: '/expertises/digital-it-advisory'
    },
    {
      old_url: '/services/ux-market-research',
      new_url: '/expertises/ux-market-research'
    },
    {
      old_url: '/services/development-consultation',
      new_url: '/expertises/development-consultation'
    },
    {
      old_url: '/services/monitoring-analytics',
      new_url: '/expertises/monitoring-analytics'
    },
    {
      old_url: '/services/brand-development',
      new_url: '/expertises/brand-development'
    },
    {
      old_url: '/services/ux-ui-design',
      new_url: '/expertises/ux-ui-design'
    },
    {
      old_url: '/services/content-creation',
      new_url: '/expertises/content-creation'
    },
    {
      old_url: '/services/motion-videography',
      new_url: '/expertises/motion-videography'
    },
    {
      old_url: '/services/ios-android-development',
      new_url: '/expertises/ios-android-development'
    },
    {
      old_url: '/services/web-development',
      new_url: '/expertises/web-development'
    },
    {
      old_url: '/services/e-commerce-solutions',
      new_url: '/expertises/e-commerce-solutions'
    },
    {
      old_url: '/services/search-engine-optimization',
      new_url: '/expertises/search-engine-optimization'
    },
    {
      old_url: '/services/creative-campaign',
      new_url: '/expertises/creative-campaign'
    },
    {
      old_url: '/services/social-media-management',
      new_url: '/expertises/social-media-management'
    },
    {
      old_url: '/services/digital-advertising',
      new_url: '/expertises/digital-advertising'
    },
    {
      old_url: '/services/influencer-marketing',
      new_url: '/expertises/influencer-marketing'
    },
    {
      old_url: '/expertises/digital-it-advisory',
      new_url: '/expertises/digital-transformation-strategy'
    },
    {
      old_url: '/expertises/ux-market-research',
      new_url: '/expertises/customer-experience-strategy'
    },
    {
      old_url: '/expertises/development-consultation',
      new_url: '/expertises/it-strategy-and-governance'
    },
    {
      old_url: '/expertises/monitoring-analytics',
      new_url: '/expertises/strategic-data-analytics'
    },
    {
      old_url: '/expertises/brand-development',
      new_url: '/expertises/brand-equity-management'
    },
    {
      old_url: '/expertises/ux-ui-design',
      new_url: '/expertises/digital-experience-design'
    },
    {
      old_url: '/expertises/content-creation',
      new_url: '/expertises/strategic-content-marketing'
    },
    {
      old_url: '/expertises/motion-videography',
      new_url: '/expertises/visual-storytelling'
    },
    {
      old_url: '/expertises/ios-android-development',
      new_url: '/expertises/mobile-application-development'
    },
    {
      old_url: '/expertises/web-development',
      new_url: '/expertises/web-application-development'
    },
    {
      old_url: '/expertises/e-commerce-solutions',
      new_url: '/expertises/digital-commerce-solutions'
    },
    {
      old_url: '/expertises/creative-campaign',
      new_url: '/expertises/integrated-marketing-campaigns'
    },
    {
      old_url: '/ideas/peran-and-ide-aplikasi-mobile-untuk-komunitas-olahraga',
      new_url:
        '/ideas/ide-ide-aplikasi-mobile-untuk-menghubungkan-sesama-penggemar-olahraga'
    },
    {
      old_url: '/ideas/optimalkan-konten-dengan-analytics-meta-business-suite',
      new_url:
        '/ideas/memaksimalkan-kinerja-konten-dengan-fitur-analytics-di-meta-business-suite'
    },
    {
      old_url: '/ideas/screencasting-sebagai-metode-pembelajaran-modern',
      new_url:
        '/ideas/menciptakan-pengalaman-belajar-yang-lebih-menarik-dengan-screencasting'
    },
    {
      old_url: '/ideas/penerapan-wms-untuk-keberhasilan-omnichannel-retail',
      new_url:
        '/ideas/omnichannel-retail-dan-dampaknya-terhadap-warehouse-management-system-omnichannel-retail-dan-dampaknya-terhadap-warehouse-management-system'
    },
    {
      old_url: '/ideas/peran-digital-agency-untuk-transformasi-digital-bisnis',
      new_url:
        '/ideas/pentingnya-layanan-digital-agency-untuk-bisnis-indonesia-di-era-digital'
    },
    {
      old_url: '/ideas/retail-management-system-kunci-sukses-penjualan-ritel',
      new_url:
        '/ideas/mengenal-retail-management-system-sebagai-solusi-untuk-meningkatkan-penjualan-ritel'
    },
    {
      old_url: '/ideas/penerapan-sales-performance-management-di-era-digital',
      new_url:
        '/ideas/implementasi-sistem-sales-performance-management-dalam-transformasi-digital'
    },
    {
      old_url: '/ideas/implementasi-order-management-workflow-untuk-bisnis',
      new_url:
        '/ideas/order-management-workflow-solusi-operasional-perusahaan-dan-kepuasan-pelanggan'
    },
    {
      old_url:
        '/ideas/penelitian-etnografi-dalam-ux-arti-jenis-metode-dan-manfaat',
      new_url:
        '/ideas/ethnographic-research-arti-jenis-metode-dan-manfaat-dalam-ux'
    },
    {
      old_url: '/ideas/10-tips-you-tube-shorts-untuk-tingkatkan-pariwisata',
      new_url:
        '/ideas/10-tips-optimalkan-konten-you-tube-shorts-untuk-industri-pariwisata'
    },
    {
      old_url: '/ideas/pahami-microblog-untuk-berbagi-konten-di-era-digital',
      new_url:
        '/ideas/pengertian-manfaat-dan-contoh-microblog-yang-digemari-pengguna'
    },
    {
      old_url: '/ideas/bangun-komunikasi-pelanggan-dengan-whats-app-business',
      new_url:
        '/ideas/manfaat-whats-app-for-business-dalam-meningkatkan-interaksi-pelanggan'
    },
    {
      old_url: '/ideas/kuasai-digital-skills-di-era-teknologi-saat-ini',
      new_url:
        '/ideas/mengembangkan-digital-skills-sebagai-investasi-karier-di-era-teknologi'
    }
  ]
}
